import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';
import { UntypedFormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-customer-changelog',
	templateUrl: './customer-changelog.component.html',
	styleUrls: ['./customer-changelog.component.scss']
})
export class CustomerChangelogComponent implements OnChanges {
	@Input() customerdata: any = false;
	@Input() debtorno: any = false;
	changelog: any[] = [];   //unfiltered
	changelog_f: any[] = []; //filtered
	loading = false;
	multiple_branches:any =  false;

	fromdateCtrl = new UntypedFormControl('')
	todateCtrl = new UntypedFormControl('')
	searchbar = new UntypedFormControl('');
	branchcode = new UntypedFormControl('all');
	changelog_type = new UntypedFormControl('all');

	exportingpdf = false;
	exportingxlsx = false;
	exporting = false;

	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [25, 50, 100];
	pagesizedefault = 25;

	constructor( public cd: ChangeDetectorRef, private customerService: CustomerService, private globalSearchService: GlobalSearchService, private printService: PrintService) {
		this.defaultDateranges(6);
	
		this.changelog_type.valueChanges.subscribe(()=>{
			this.filterlogs();
		});		
		this.branchcode.valueChanges.subscribe(()=>{
			this.filterlogs();
		})
		this.todateCtrl.valueChanges.subscribe((newV)=>{
			if(this.fromdateCtrl.value && this.fromdateCtrl.value != '' && newV){
				this.filterlogs();
			}
		})
	}

	defaultDateranges(monthsBack){
		const start = new Date();
		const today = new Date();
		start.setMonth(start.getMonth() - Number(monthsBack));
		let fromdate = start;
		let todate = new Date(today);
		this.fromdateCtrl.setValue(fromdate);
		this.todateCtrl.setValue(todate);
	}



	filterlogs(){		
		const from = this.fromdateCtrl.value;
		const to = this.todateCtrl.value;
		const type = this.changelog_type.value.toUpperCase();
		const search = this.searchbar.value.toUpperCase();
		const branchcode = this.branchcode.value.toUpperCase();

		let filtered = [...this.changelog].filter((changes)=>{
			let should_return = true;
			
			if(type !== 'ALL'){
				if(type !== changes.type.toUpperCase()){
					should_return = false;	
				}
			}

			const changed_at = new Date(changes.changed_at).setHours(0,0,0,0);
			const from_d = new Date(from).setHours(0,0,0,0);
			const to_d = new Date(to).setHours(0,0,0,0);

			if(changed_at < from_d || changed_at > to_d){
				should_return = false;
			}
			
			if(search.length){
				const haystack = Object.values(changes).join(' ').toUpperCase();
				const needles = search.split(' ');
				needles.forEach(searchon => {
					if(should_return && !haystack.includes(searchon)){
						should_return = false;
					}
				});
			}

			if(this.multiple_branches && branchcode !== 'ALL'){
				if(changes.branchcode !== branchcode){
					should_return = false;
				}
			}

			if(should_return){
				return changes;
			}
		})
		
		this.changelog_f = filtered;
		this.setPagination(filtered);
	}
    

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.debtorno) {
			this.loadChangelog();
		}
	}

	buildHtmlAndExport(doctype: string): void {
		let html = '<table style="width:100%"><thead><tr style="background:black;color:white">';
		html += '<th style="text-align:left">Date</th>';
		html += '<th style="text-align:left">Changed By</th>';
		html += '<th style="text-align:left">Type</th>';
		html += '<th style="text-align:left">Table</th>';
		html += '<th style="text-align:left">Branch</th>';
		html += '<th style="text-align:left">Field</th>';
		html += '<th style="text-align:left">Old Value</th>';
		html += '<th style="text-align:left">New Value</th>';
		html += '</tr></thead><tbody>';
		this.changelog_f.forEach(entry => {
			html += '<tr>';
			html += `<td>${new Date(entry.changed_at).toLocaleString()}</td>`;
			html += `<td>${entry.changed_by ?? ''}</td>`;
			html += `<td>${entry.type ?? ''}</td>`;
			html += `<td>${entry.table ?? ''}</td>`;
			html += `<td>${entry.branchcode ?? ''}</td>`;
			html += `<td>${entry.field_changed ?? ''}</td>`;
			html += `<td>${entry.old_value ?? '-'}</td>`;
			html += `<td>${entry.new_value ?? '-'}</td>`;
			html += '</tr>';
		});
		html += '</tbody></table>';

		if(doctype === 'pdf'){
			this.exportingpdf = true;
			this.exportPdf(html);
		}else{
			this.exportingxlsx = true;
			this.exportXls(html);
		}
	}

	exportPdf(html: string): void {
		const today = new Date().toLocaleString();
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Customer Changelog ${this.debtorno} - ${today}`,
			title: `Customer Changelog - ${this.debtorno}`,
			subtitle: 'Created ' + today,
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exportingpdf = false;
		});
	}

	exportXls(html: string): void {
		const today = new Date().toLocaleString();
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Customer Changelog ${this.debtorno} - ${today}`,
			title: `Customer Changelog - ${this.debtorno}`,
			subtitle: 'Created ' + today,
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exportingxlsx = false;
		});
	}


	loadChangelog(): void {
		if(!this.debtorno || this.debtorno == ''){
			return;
		}else{
			this.resetFilters();
		}

		this.loading = true;
		this.customerService.getCustomerChangelog(this.debtorno).subscribe({
			next: (results: any) => {
				this.changelog = Array.isArray(results) ? results : [];
				this.changelog_f = Array.isArray(results) ? results : [];
				this.hasBranches(results);
				this.loading = false;
				this.setPagination(this.changelog_f);
			},
			error: () => {
				this.changelog = [];
				this.changelog_f = [];
				this.loading = false;
				this.multiple_branches = false;
				this.setPagination([]);
				
			}
		});
	}

	hasBranches(results){
		this.multiple_branches = [...new Set((Array.isArray(results) ? results : []).map((i)=>{ if(!isNaN(Number(i.branchcode))){ return i.branchcode; } }).filter(Boolean))];
		this.multiple_branches = this.multiple_branches.length > 1 ? this.multiple_branches : false; 
		if(this.multiple_branches){
			this.multiple_branches = this.multiple_branches.sort((a,b)=>{
				if(Number(a) > Number(b)){return 1;}
				if(Number(b) < Number(a)){return -1;}
				if(Number(b) == Number(a)){return 0;}
			})
		}
	}

	resetFilters(){
		this.changelog_f = this.changelog;
		this.setPagination(this.changelog);
		this.searchbar.setValue('');
		this.branchcode.setValue('all');
		this.changelog_type.setValue('all');
		this.defaultDateranges(6);
		
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this.cd.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}
}
